import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import { useAtom } from "jotai";
import SectionRecord from "models/view-models/section-record";
import {
    SECTION_DRAG_AND_DROP_SCOPE_NAME,
    SECTION_DRAGGABLE_ID,
} from "organisms/drag-and-drop/use-drag-and-drop-section";
import { useSharedDragAndDropContext } from "utilities/contexts/shared-drag-and-drop/shared-drag-and-drop-context";
import { DraggableSection } from "utilities/atoms/section-drag-and-drop/draggable-section";
import { ScopedDragAndDropData } from "utilities/contexts/shared-drag-and-drop/scoped-drag-and-drop-data";

interface SectionDraggableData extends ScopedDragAndDropData {
    section?: SectionRecord;
}

export interface SectionDraggableProps {
    active?: boolean;
    section?: SectionRecord;
}

const CSS_CLASS_NAME = "c-section-draggable";

const SectionDraggable = ({
    active = false,
    section,
}: SectionDraggableProps) => {
    const data: SectionDraggableData = {
        scope: SECTION_DRAG_AND_DROP_SCOPE_NAME,
        section: section,
    };

    const [draggingSection] = useAtom(DraggableSection);
    const { isDragging } = useSharedDragAndDropContext();
    const { attributes, listeners, setNodeRef } = useDraggable({
        id: `${SECTION_DRAGGABLE_ID}__${section?.id}`,
        data: data,
    });

    return (
        <button
            className={CSS_CLASS_NAME}
            ref={setNodeRef}
            {...listeners}
            {...attributes}>
            {active && isDragging ? (
                // Display view, temporary
                <article className={`${CSS_CLASS_NAME}__sectionCard`}>
                    {draggingSection?.getTitle()}
                </article>
            ) : (
                <Icon
                    cssClassName={`${CSS_CLASS_NAME}__icon`}
                    size={IconSizes.Large}
                    type={Icons.DragAndDrop}
                />
            )}
        </button>
    );
};

export default SectionDraggable;
